/**
 * Type to define the type of a visualization value
 */
export type VisualizationType = "FloatValueVisualization" | "ScreenContentVisualization"

export const VISUALIZATION_TYPE_FLOAT: VisualizationType = "FloatValueVisualization"
export const VISUALIZATION_TYPE_SCREEN: VisualizationType = "ScreenContentVisualization"